import React from 'react'

interface TestimonialData {
  name: string
  role: string
  image: string
  quote: string
  link?: string
  stats: Array<{
    value: string
    label: string
    description: string
  }>
}

const testimonials: TestimonialData[] = [
  {
    name: "M. Anowar Hossain",
    role: "Executive Chairman, Growing Together OPC",
    image: "/person/anowar-hossain.webp",
    quote: "LogicNext designed and built a fast, SEO‑friendly website for Growing Together OPC. The site improved accessibility, performance, and engagement across devices, helping the organization communicate its mission effectively.",
    link: "https://growingtogether-int.org",
    stats: [
      { value: "98%", label: "Customer Satisfaction", description: "From verified reviews" },
      { value: "3.8x", label: "ROI Improvement", description: "Within first quarter" }
    ]
  },
  {
    name: "SM Rakibul Kabir",
    role: "BDS, PGT (Oral Surgery)",
    image: "/person/rakib.png",
    quote: "We built a custom dental management software tailored to clinical workflows — appointments, treatment records, billing, and reporting — streamlining operations and improving day‑to‑day efficiency across the practice.",
    link: "",
    stats: [
      { value: "4.2x", label: "Team Efficiency", description: "Proven productivity gains" },
      { value: "72%", label: "Reduced Task Time", description: "Across all projects" }
    ]
  }
]

interface TestimonialsSectionProps {
  className?: string
}

const TestimonialsSection = React.memo(function TestimonialsSection({ className }: TestimonialsSectionProps) {
  return (
    <section className={`relative z-10 pt-48 pb-24 container mx-auto px-6 ${className}`}>
      <div className="max-w-5xl mx-auto space-y-12 text-left">
        <div className="text-center space-y-4">
          <p className="text-sm font-medium text-indigo-400">4+ Companies</p>
          <h2 className="text-3xl md:text-5xl font-bold text-white">Real results from real users</h2>
        </div>

        {testimonials.map((testimonial, index) => (
          <div key={index} className="grid md:grid-cols-12 gap-8 items-center bg-slate-900/30 p-8 rounded-3xl border border-white/5">
            <div className="md:col-span-3 aspect-square rounded-2xl overflow-hidden border border-white/10">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="md:col-span-6 space-y-6">
              <blockquote className="text-xl leading-relaxed text-slate-300">
                "{testimonial.quote}"
                {testimonial.link && (
                  <>
                    <br />
                    <span className="text-slate-500 text-sm">Website: </span>
                    <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">
                      {testimonial.link.replace("https://", "")}
                    </a>
                  </>
                )}
                <br />
                <span className="text-slate-500 text-sm">We value our client's privacy</span>
              </blockquote>
              <div>
                <div className="font-semibold text-white">{testimonial.name}</div>
                <div className="text-slate-500 text-sm">{testimonial.role}</div>
              </div>
            </div>
            <div className="md:col-span-3 space-y-8 border-l border-white/10 pl-8">
              {testimonial.stats.map((stat, statIndex) => (
                <div key={statIndex}>
                  <div className="text-4xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-sm font-medium text-white mb-1">{stat.label}</div>
                  <div className="text-xs text-slate-500">{stat.description}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
})

export default TestimonialsSection
